import { dayBounds, type Settings } from '@wiztime/core';
import { ValidationError } from '../errors';

/**
 * Placement rules of the storage layer. Blocks may overlap freely (overlay records,
 * ui-redesign §2.1.2); the only hard boundary is the personal day. Expired drafts are purged
 * when a personal day is loaded (`Store.purgeExpiredDrafts`), not here.
 */

/** Throw unless `span` lies inside the personal day that starts at `settings.dayStartMin`. */
export function assertWithinDay(
  span: { startMin: number; endMin: number },
  settings: Pick<Settings, 'dayStartMin'>,
): void {
  const bounds = dayBounds(settings.dayStartMin);
  if (!Number.isInteger(span.startMin) || !Number.isInteger(span.endMin)) {
    throw new ValidationError('Block times must be whole minutes');
  }
  if (span.startMin >= span.endMin) throw new ValidationError('A block must start before it ends');
  if (span.startMin < bounds.startMin || span.endMin > bounds.endMin) {
    throw new ValidationError(
      `The block must lie within the personal day (${bounds.startMin} to ${bounds.endMin})`,
    );
  }
}
